import { BaseModel } from "@blue-chip/core";
import BidGroupVendorSpecQuote from "./BidGroupVendorSpecQuote";
import Spec from "./Spec";

export default class BidGroupVendorSpecQuoteItem extends BaseModel {
  static get belongsTo() {
    return [BidGroupVendorSpecQuote, Spec];
  }
}
